import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import api from "../../utils/api";
import { StringNumber } from "../../types";

export type T_Evento = {
  id: number,
  atividade: number,
  descricao: string,
  inicio: string | null,
  fim: string | null,
  cidade: number,
  cep: string,
  bairro: string,
  rua: string,
  numero: string,
  complemento: string,
  pgto: boolean,
  valor: number,
  whatsapp: string,
  ativo: boolean,
  inscricao: boolean,
  celula: number,
}

export const SelectCelula = ({ idministerio, action, valor: _val }: { idministerio: number | string, action: any, valor?: StringNumber | null }) => {

  const [celulas, setCelulas] = useState<T_Evento[]>();


  const getCelulas = async () => {
    try {
      const req = await api.get('ministerio/celula/ministerio/' + idministerio);
      const res = req?.data;

      setCelulas(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getCelulas()
  }, [idministerio])

  const Selecter = useCallback(() => {
    return (
      <Select
      value={_val}
      onChange={action}
    >
      {
        celulas?.map(
          ministerio =>
            <MenuItem value={ministerio?.id}>
              {ministerio?.descricao}
            </MenuItem>
        )
      }
    </Select>
    )

  }, [idministerio, celulas, _val])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>PG’s</FormLabel>
        {
          celulas && (
            <Selecter/>
          )
        }
      </Grid>
    </>
  )
}
